// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterContactIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 16">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.953 2.047c.334.333.626.69.875 1.07.25.38.464.782.641 1.203.178.421.31.857.399 1.305.088.448.132.906.132 1.375v6.5c0 .416-.145.77-.437 1.063A1.45 1.45 0 0 1 12.5 15H9.923a1.49 1.49 0 0 1-.548.719c-.26.188-.552.281-.875.281-.416 0-.77-.147-1.063-.437A1.452 1.452 0 0 1 7 14.5c0-.417.147-.77.437-1.063A1.447 1.447 0 0 1 8.5 13c.323 0 .615.093.875.281.261.187.442.427.548.719H12.5a.48.48 0 0 0 .352-.148A.485.485 0 0 0 13 13.5v-1.579c-.083.022-.167.04-.25.055a1.452 1.452 0 0 1-1.313-.413A1.452 1.452 0 0 1 11 10.5v-2c0-.417.147-.77.437-1.063a1.447 1.447 0 0 1 1.306-.414c.077.016.158.034.241.054V7a5.714 5.714 0 0 0-.601-2.156 6.123 6.123 0 0 0-1.312-1.743A6.143 6.143 0 0 0 9.219 1.93 5.779 5.779 0 0 0 7 1.5c-.781 0-1.52.143-2.219.43A6.176 6.176 0 0 0 2.93 3.1a6.123 6.123 0 0 0-1.312 1.743A5.739 5.739 0 0 0 1.016 7v.077a6.8 6.8 0 0 1 .243-.054 1.445 1.445 0 0 1 1.304.415c.292.29.437.644.437 1.062v2c0 .416-.145.77-.437 1.063A1.45 1.45 0 0 1 1.5 12c-.416 0-.77-.147-1.063-.437A1.452 1.452 0 0 1 0 10.5V7c0-.47.044-.927.133-1.375.088-.448.222-.884.399-1.305.176-.421.39-.823.64-1.203.25-.38.541-.737.875-1.07.333-.334.69-.626 1.07-.875.38-.25.782-.464 1.203-.641A6.799 6.799 0 0 1 7 0c.47 0 .927.044 1.375.132.448.09.884.221 1.305.399.421.177.823.39 1.203.641.38.25.737.541 1.07.875"
            />
        </svg>
    );
};

export default React.memo(FooterContactIcon);
